import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from "react";
import { StoreType } from "../model/rankings";
import { AppDetailModal } from "../ui/app_store_rankings/components/AppDetailModal";

interface AppDetailModalContextType {
  open: (store: StoreType, appId: string, country?: string) => void;
  close: () => void;
}

const AppDetailModalContext = createContext<
  AppDetailModalContextType | undefined
>(undefined);

export function useAppDetailModal() {
  const ctx = useContext(AppDetailModalContext);
  if (!ctx) {
    throw new Error(
      "useAppDetailModal must be used within AppDetailModalProvider"
    );
  }
  return ctx;
}

export function AppDetailModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [store, setStore] = useState<StoreType>("ios");
  const [appId, setAppId] = useState<string>("");
  const [country, setCountry] = useState<string>("us");

  const open = useCallback(
    (store: StoreType, appId: string, country?: string) => {
      setStore(store);
      setAppId(appId);
      if (country) {
        setCountry(country);
      }
      setIsOpen(true);
    },
    []
  );

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <AppDetailModalContext.Provider value={{ open, close }}>
      {children}
      {isOpen && (
        <AppDetailModal
          store={store}
          appId={appId}
          country={country}
          onClose={close}
        />
      )}
    </AppDetailModalContext.Provider>
  );
}
